import React from 'react';
import { connect, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { MedicalInsuranceAgreementsPriceList } from '../../../models/Entities/MedicalInsuranceAgreements/MedicalInsuranceAgreementsPriceList';
import { AppState } from '../../../redux/reducers';
import { PriceListCards } from '../PriceListCards/PriceListCards.Component';

// functions
import * as ownFunctions from './AgreementPriceListFunctions';

export interface IProps {
  priceList: MedicalInsuranceAgreementsPriceList[];
  onSelectPriceList?: (PriceList: MedicalInsuranceAgreementsPriceList) => void;
  selectedId?: number;
  emptyAction?: React.ReactNode;
}

/** Listas de precios del convenio: las mismas tarjetas de la guía que usa el proveedor. */
export const AgreementsPriceListComponent = (props: IProps) => {
  const [t] = useTranslation();
  const loading = useSelector((state: AppState) => !!state.PriceList?.isLoadingAll);
  return (
    <PriceListCards<MedicalInsuranceAgreementsPriceList>
      priceList={props.priceList}
      onSelectPriceList={props.onSelectPriceList}
      selectedId={props.selectedId}
      loading={loading}
      loadingLabel={t('agreementsPriceList.loading')}
      emptyTitle={t('agreementsPriceList.noPriceLists')}
      emptyAction={props.emptyAction}
      testId="apl-list"
    />
  );
};

export default connect(
  ownFunctions.mapStateToProps,
  ownFunctions.mapDispatchToProps
)(AgreementsPriceListComponent as any);
